import DocumentsRequestedSection from './DocumentsRequestedSection.component';

export default DocumentsRequestedSection;